/**
 * Next.js styled-jsx emits `<style jsx>` which Babel turns into `jsx: true` on a DOM
 * `<style>` element. Without the styled-jsx runtime, React warns and the attribute hits
 * the DOM. Strip before compile and from stored transformed output before render/capture.
 */

/** Remove styled-jsx attributes from `<style jsx>` / `<style jsx global>` in source. */
export function stripStyledJsxFromReactSource(source: string): string {
	return source.replace(
		/<style\s+jsx\b(?:\s+global)?(?:\s*=\s*(?:\{?\s*true\s*\}?|["'][^"']*["']))?\s*/gi,
		"<style "
	);
}

/** Remove `jsx: true` props Babel emitted for styled-jsx `<style>` tags. */
export function stripStyledJsxFromTransformedCode(code: string): string {
	// Avoid a single complex regex (esbuild chokes on some alternations). Custom code
	// only uses classic React.createElement for style after @babel/standalone.
	return code
		.replace(
			/createElement\(\s*["']style["']\s*,\s*\{\s*jsx:\s*true\s*,?\s*/g,
			'createElement("style", { '
		)
		.replace(
			/createElement\(\s*["']style["']\s*,\s*\{jsx:\s*!0\s*,?\s*/g,
			'createElement("style", {'
		)
		.replace(
			/createElement\(\s*["']style["']\s*,\s*\{\s*jsx:\s*!0\s*,?\s*/g,
			'createElement("style", { '
		);
}
